import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject, OnInit, signal, viewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { filter, map, switchMap } from 'rxjs';
import { ActivateLearningResourceEnrollmentDialogComponent } from 'src/app/components/main/employees/rrhh/activate-learning-resource-enrollment-dialog/activate-learning-resource-enrollment-dialog.component';
import { LearningResourceUserFormationProfileComponent } from 'src/app/components/main/shared/learning-resource-user-formation-profile/learning-resource-user-formation-profile.component';
import { User } from 'src/app/models/user.model';
import { ApiService } from 'src/app/services';

@Component({
  selector: 'app-formations-by-user-detail',
  templateUrl: './formations-by-user-detail.component.html',
  styleUrl: './formations-by-user-detail.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatIconModule, RouterLink, LearningResourceUserFormationProfileComponent],
})
export class FormationsByUserDetailComponent implements OnInit {
  private readonly api_service = inject(ApiService);
  private readonly activated_route = inject(ActivatedRoute);
  private readonly change_detector_ref = inject(ChangeDetectorRef);
  private readonly mat_dialog = inject(MatDialog);
  private readonly destroy_ref = inject(DestroyRef);

  private readonly formation_profile = viewChild(LearningResourceUserFormationProfileComponent);

  readonly user = signal<User | null>(null);
  readonly loading_user = signal(true);

  ngOnInit(): void {
    this.activated_route.paramMap
      .pipe(
        map(params => params.get('user_id')),
        filter((user_id): user_id is string => user_id !== null),
        switchMap(user_id => {
          this.loading_user.set(true);

          return this.api_service.getUser(user_id);
        }),
        takeUntilDestroyed(this.destroy_ref)
      )
      .subscribe({
        next: (user: User): void => {
          this.user.set(user);
          this.loading_user.set(false);
          this.change_detector_ref.markForCheck();
        },
        error: (): void => {
          this.loading_user.set(false);
          this.change_detector_ref.markForCheck();
        },
      });
  }

  openActivateDialog(): void {
    const user = this.user();

    if (!user) {
      return;
    }

    const dialog_ref = this.mat_dialog.open(ActivateLearningResourceEnrollmentDialogComponent, {
      width: '520px',
      minWidth: '400px',
      data: { user },
    });

    dialog_ref
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroy_ref))
      .subscribe((should_refresh: boolean | undefined): void => {
        if (should_refresh) {
          this.formation_profile()?.reload();
        }
      });
  }
}
